import { N as Navigation, S as Swiper } from './navigation-BVjU0h-z.js';

class SkewedSlider extends HTMLElement {
  connectedCallback() {
    const nextEl = `.swiper-next-${this.dataset.sectionId}`;
    const prevEl = `.swiper-prev-${this.dataset.sectionId}`;

    const defaultOptions = {
      modules: [Navigation],

      navigation: {
        nextEl,
        prevEl,
      },
    };
    //  HTML
    const options = JSON.parse(
      this.querySelector('[type="application/json"]')?.textContent || '{}'
    );

    this.initSwiper({ ...defaultOptions, ...options });
  }

  initSwiper(options) {
    const swiper = this.querySelector('.swiper--skewed');
    const swiperInstance = new Swiper(swiper, options);

    // Hide navigation if all slides fit
    const checkNavigation = () => {
      const navButtons = document.querySelectorAll(
        `[class*="swiper-prev-${this.dataset.sectionId}"], [class*="swiper-next-${this.dataset.sectionId}"]`
      );

      // Calculate if all slides fit within the container
      const containerWidth = swiperInstance.el.offsetWidth;
      let totalWidth = 0;

      swiperInstance.slides.forEach((slide) => {
        totalWidth += slide.offsetWidth;
      });

      // Add spacing between slides
      const spacing = swiperInstance.params.spaceBetween * (swiperInstance.slides.length - 1);
      totalWidth += spacing;

      if (totalWidth <= containerWidth) {
        navButtons.forEach((btn) => (btn.style.display = 'none'));
      } else {
        navButtons.forEach((btn) => (btn.style.display = ''));
      }
    };

    swiperInstance.on('init', () => {
      requestAnimationFrame(checkNavigation);
    });
    swiperInstance.on('resize', checkNavigation);
    setTimeout(checkNavigation, 100);
  }
}

customElements.define('skewed-slider', SkewedSlider);
